import { ActionTitle } from "@/components/actionTitle/ActionTitle";
import { ListContainer } from "@/components/layout/ListContainer";
import { HomeProjectItemList } from "@/features/homeProject/HomeProjectItemList";
import { t } from "@repo/translation";
import { PaddedContainer, SectionContainer } from "@repo/ui";

import { useActiveProject } from "../project/ActiveProject";
import { Inspirations } from "./inspiration/Inspirations";

export const HomeProjectSection = () => {
  const { opportunity } = useActiveProject();

  const prePlanningDetails = opportunity?.prePlanningDetails;

  const inspirations = prePlanningDetails?.filter(
    (detail) =>
      detail.planningType === "INSPIRATION" ||
      detail.planningType === "IMAGINATION"
  );

  const measurements = prePlanningDetails?.filter(
    (detail) => detail.planningType === "MEASUREMENT"
  );

  return (
    <PaddedContainer>
      <SectionContainer>
        <ActionTitle
          title={`${t("label.inspiration")} (${inspirations?.length ?? 0})`}
        />
      </SectionContainer>
      <ListContainer>
        <Inspirations inspirations={inspirations} />
        <HomeProjectItemList data={measurements} />
      </ListContainer>
    </PaddedContainer>
  );
};
